import type { Tier } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'

export const useMCProCertsCatalogValue = (): string => {
  const { tiers } = useStaticData<{ tiers?: Tier[] }>()

  const highestTier = tiers?.reduce<Tier | undefined>(
    (highest, tier) =>
      !highest || tier.hierarchy > highest.hierarchy ? tier : highest,
    undefined,
  )

  return highestTier?.monetizedCertificatesCatalogValue ?? ''
}
